import { IChildrenProp } from 'types/components/components.interface';
import './InfoBoxItem.scss';
import { useTranslation } from 'react-i18next';
import { InfoBoxContext } from '../../InfoBox';
import { useContext } from 'react';

interface IInfoBoxItemProps extends IChildrenProp {
  label?: string;
  value?: string;
}

const InfoBoxItem = ({ children, label, value }: IInfoBoxItemProps) => {
  const { t } = useTranslation();
  const { loading } = useContext(InfoBoxContext);
  return (
    <div
      className={`info-box-item ${children ? 'children' : ''} ${
        !label && !value ? 'empty' : ''
      }`}>
      {label && (
        <div className='label' title={label}>
          {label}
        </div>
      )}
      {!loading ? (
        children ?? (
          <div className='value' title={value}>
            {value ?? t('info-box.nullValue')}
          </div>
        )
      ) : (
        <span className='loading' />
      )}
    </div>
  );
};

export default InfoBoxItem;
